import { render } from "./ImageTitle.vue?vue&type=template&id=0f3b26fb"
import script from "./ImageTitle.vue?vue&type=script&lang=ts"
export * from "./ImageTitle.vue?vue&type=script&lang=ts"
script.render = render

export default script